import { ScheduledSessionsTableRow } from "./ScheduledSessionsTableRow";
import { TLTableWithHeader } from "../Table/TLTableWithHeader";

export const ScheduledSessionsCard = ({ data, firstRowExtraInfo }) => {
  if (!data?.length) return null;

  return (
    <TLTableWithHeader
      headerBefore={
        <ScheduledSessionsTableRow
          colSpan={1}
          data={data}
          firstRowExtraInfo={firstRowExtraInfo}
          sx={{ bgcolor: "white" }}
          type="user"
        />
      }
    />
  );
};
